import { faker } from "@faker-js/faker";

import { merge } from "@/__mocks__/mockHelpers";
import { LogoutReason } from "@/constants/Login";
import {
  AdminEpisodeStatus,
  InTreatmentUniversalStatusCodes,
  PostTreatmentUniversalStatusCodes,
  PreTreatmentUniversalStatusCodes,
  UniversalStatusCode,
} from "@/constants/User";
import type { UserTabSelectorTabProps } from "@/ui/core/UserTabSelector";

const fakeLogoutReason = (): LogoutReason =>
  faker.helpers.arrayElement(Object.values(LogoutReason));

const fakeAdminEpisodeStatus = (): AdminEpisodeStatus =>
  faker.helpers.arrayElement(Object.values(AdminEpisodeStatus));

const fakeUniversalStatusCode = (): UniversalStatusCode =>
  faker.helpers.arrayElement(Object.values(UniversalStatusCode));

const fakePreTreatmentUniversalStatusCode = (): UniversalStatusCode =>
  faker.helpers.arrayElement(PreTreatmentUniversalStatusCodes);

const fakeInTreatmentUniversalStatusCode = (): UniversalStatusCode =>
  faker.helpers.arrayElement(InTreatmentUniversalStatusCodes);

const fakePostTreatmentUniversalStatusCode = (): UniversalStatusCode =>
  faker.helpers.arrayElement(PostTreatmentUniversalStatusCodes);

const fakeUserTab = (
  overrides?: DeepPartial<UserTabSelectorTabProps>,
): UserTabSelectorTabProps => {
  const props: UserTabSelectorTabProps = {
    badgeCount: faker.number.int({ max: 100, min: 0 }),
    universalStatusCode: fakeUniversalStatusCode(),
    userId: faker.string.uuid(),
    userName: faker.person.fullName(),
  };

  return merge(props, overrides);
};

export {
  fakeAdminEpisodeStatus,
  fakeInTreatmentUniversalStatusCode,
  fakeLogoutReason,
  fakePostTreatmentUniversalStatusCode,
  fakePreTreatmentUniversalStatusCode,
  fakeUniversalStatusCode,
  fakeUserTab,
};
